/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { Link } from "react-router-dom";
import { Container } from "reactstrap";
import { breakpoints } from "../../../constants/mediaqueries";
import logo from "../../../img/logo-experience-fruit-quality.png";
import { BottomBar } from "../../Helper/BottomBar";
import { PageHeader, PageHeaderProps } from "./PageHeader";

const sidebarStyle = css`
    max-width: 100%;

    @media (min-width: ${breakpoints[3]}px) {
        max-width: 460px;
    }
`;

const contentStyle = css`
    min-height: 100dvh;
    min-width: 0;
`;

export interface SidebarPageLayoutProps extends PageHeaderProps {
    header?: React.ReactNode;
    sidebar?: React.ReactNode;
    bottomBar?: React.ReactNode;
    withLogo?: boolean;
    styleAsCard?: boolean;
}

const SidebarPageLayout = ({ title, withLogo, children, header, breadcrumbs, sidebar, bottomBar, styleAsCard = true }: SidebarPageLayoutProps) => {
    return (
        <Container>
            <div className="w-100 d-flex flex-column flex-xl-row-reverse justify-content-between align-items-start pt-3 pb-1 gap-5 gap-xl-3">
                <div className={`w-100 flex-1 ${styleAsCard ? "bg-white shadow-sm rounded-3 px-3 px-md-5 pb-3 pb-md-5" : ""}`} css={contentStyle}>
                    <PageHeader breadcrumbs={breadcrumbs} title={title}>
                        {header}
                    </PageHeader>

                    {children}

                    {!!bottomBar && (
                        <BottomBar>{bottomBar}</BottomBar>
                    )}
                </div>

                <div className="w-100 flex-1 px-3 px-md-5 pt-5" css={sidebarStyle}>
                    {withLogo && (
                        <div className="p-5 pb-0">
                            <Link to="/" >
                                <img src={logo} alt="" css={css`height: 48px; padding-bottom: 8px;`} />
                            </Link>
                        </div>
                    )}

                    <div className="flex flex-column gap-5">
                        {sidebar}
                    </div>
                </div>
            </div>
        </Container>
    );
};

export default SidebarPageLayout;
